/**
 * Spacer Component for Puck Editor
 * 
 * Jarak vertikal antar komponen
 */

import type { ComponentConfig } from '@measured/puck'

export interface SpacerProps {
  size: 'small' | 'medium' | 'large' | 'xlarge'
  showDivider: boolean
  dividerColor: string
}

const sizeClasses = {
  small: 'h-4',
  medium: 'h-8',
  large: 'h-16',
  xlarge: 'h-24',
}

export function Spacer({ size, showDivider, dividerColor }: SpacerProps) {
  if (showDivider) {
    return (
      <div className={`${sizeClasses[size]} flex items-center`}>
        <hr
          className="w-full border-t"
          style={{ borderColor: dividerColor || '#e5e7eb' }}
        />
      </div>
    )
  }

  return <div className={sizeClasses[size]} />
}

export const SpacerConfig: ComponentConfig<SpacerProps> = {
  label: 'Spasi',
  defaultProps: {
    size: 'medium',
    showDivider: false,
    dividerColor: '#e5e7eb',
  },
  fields: {
    size: {
      type: 'select',
      label: 'Ukuran',
      options: [
        { label: 'Kecil', value: 'small' },
        { label: 'Sedang', value: 'medium' },
        { label: 'Besar', value: 'large' },
        { label: 'Ekstra Besar', value: 'xlarge' },
      ],
    },
    showDivider: {
      type: 'radio',
      label: 'Tampilkan Garis',
      options: [
        { label: 'Ya', value: true },
        { label: 'Tidak', value: false },
      ],
    },
    dividerColor: {
      type: 'text',
      label: 'Warna Garis (HEX)',
    },
  },
  render: Spacer,
}
